<template>
  <div class="main-sponsors">
    <img src="@/assets/icons/about-sponsor-1.png" :srcset="srcset[0]" alt="sponsor" />
    <img src="@/assets/icons/about-sponsor-2.png" :srcset="srcset[1]" alt="sponsor" />
  </div>
</template>

<script>
export default {
  name: 'MainSponsors',
  data: () => ({
    srcset: [
      `${require('@/assets/icons/about-sponsor-1@2x.png')} 2x`,
      `${require('@/assets/icons/about-sponsor-2@2x.png')} 2x`,
    ],
  }),
}
</script>

<style lang="scss">
.main-sponsors {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  justify-items: flex-start;
  margin-top: 8px;

  @include mobile {
    flex-wrap: wrap;
    margin: -8px;
    margin-top: 32px;
  }

  img {
    min-width: 0;

    @include mobile {
      max-width: 160px;
    }
  }

  img + img {
    @include PC {
      margin-left: 13%;
    }

    @include mobile {
      margin: 8px;
    }
  }
}
</style>
